import script from "./LingoStudentSpellingKC.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoStudentSpellingKC.vue?vue&type=script&setup=true&lang=ts"

import "./LingoStudentSpellingKC.vue?vue&type=style&index=0&id=08e421b0&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e421b0"]])

export default __exports__